<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-fill-${color}`"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.31683 14.3833C9.11683 14.5833 8.87516 14.6833 8.59183 14.6833C8.3085 14.6833 8.06683 14.5833 7.86683 14.3833L1.61683 8.13331C1.50572 8.0222 1.43072 7.90553 1.39183 7.78331C1.35294 7.66109 1.3335 7.53331 1.3335 7.39998V2.33331C1.3335 2.04442 1.42794 1.80554 1.61683 1.61665C1.80572 1.42776 2.04461 1.33331 2.3335 1.33331H7.40016C7.5335 1.33331 7.66683 1.35276 7.80016 1.39165C7.9335 1.43054 8.05572 1.50554 8.16683 1.61665L14.3835 7.83331C14.5946 8.04442 14.7002 8.29165 14.7002 8.57498C14.7002 8.85831 14.5946 9.10553 14.3835 9.31665L9.31683 14.3833ZM8.6335 13.7L13.7002 8.63331L7.40016 2.33331H2.3335V7.39998L8.6335 13.7ZM4.0835 4.93331C4.31683 4.93331 4.51961 4.8472 4.69183 4.67498C4.86405 4.50276 4.95016 4.29998 4.95016 4.06665C4.95016 3.83331 4.86405 3.63054 4.69183 3.45831C4.51961 3.28609 4.31683 3.19998 4.0835 3.19998C3.85016 3.19998 3.64739 3.28609 3.47516 3.45831C3.30294 3.63054 3.21683 3.83331 3.21683 4.06665C3.21683 4.29998 3.30294 4.50276 3.47516 4.67498C3.64739 4.8472 3.85016 4.93331 4.0835 4.93331Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'shuttle-gray',
});
</script>
